export default class NBAEntity {
  constructor() {
    this.nbaList = {};
    /**
     * Add NBAs Items
     */
    this.addItem = (id, insights) => {
      this.nbaList[id] = insights;
    };
    /**
     * The Hero Banner
     * @returns {Array} Hero Insights
     */
    this.getHeros = () => {
      return this.nbaList['C1'];
    };
    /**
     * Your Messages/Updates
     * @returns {Array} Updates Insights
     */
    this.getUpdates = () => {
      return this.nbaList['C2'];
    };
    /**
     * Product Opportunity container
     * @returns {Array} Product Insights
     */
    this.getProducts = () => {
      return this.nbaList['C3'];
    };
    /**
     * The Right Hand Banner
     * @returns {Array} Banner Insights
     */
    this.getBanners = () => {
      return this.nbaList['C4'];
    };
    /**
     * The Product Page Banner
     * @returns {Array} Banner Insights
     */
    this.getProductBanners = () => {
      return this.nbaList['C1'];
    };
    /**
     * The Splash
     * @returns {Array} Splash Insights
     */
    this.getSplash = () => {
      return this.nbaList['S1'];
    };
  }
}
